var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-input',{staticClass:"ui-input-time",attrs:{"return-masked-value":"","mask":_vm.mask,"hide-details":1},on:{"blur":_vm.handleBlur},model:{value:(_vm.pValue),callback:function ($$v) {_vm.pValue=$$v},expression:"pValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }